module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/course-1-9e4ee052968f6d57a61bb4c7a07d205c.jpg";